export default "__VITE_ASSET__CjW1duoD__"